var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Rect } from "react-native-svg";
function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M15.836 2.585h3.918a3.582 3.582 0 013.581 3.58v14.508a3.582 3.582 0 01-3.58 3.581H4.336a3.581 3.581 0 01-3.58-3.58V6.165a3.581 3.581 0 013.58-3.581h11.5zM.758 8.041h22.577",
    stroke: "#5B41F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Rect, {
    fill: "#5B41F0",
    x: 4,
    y: 11,
    width: 4,
    height: 4,
    rx: 0.8
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#5B41F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.362 4.183V.759M5.731 4.183V.759"
  }))));
}
export default SvgIconCalendar;